import { CartProductDetailModel } from './cart-product-detail-model';
import { CartOptionDetailModel } from './cart-option-detail-model';

export class CartInfoModel {
  cartProductId: number;
  langId: number;
  productId: number;
  supplierId: number;
  currencyIdUser: number;
  purpose: string;
  characterDetail: CartCharacterDetailModel;
  optionDetail: CartOptionDetailModel;
  productDetail: CartProductDetailModel;
  acceptThaiRemark: Boolean;
  searchId: string;
  lineItems: CartLineItemsModel[];
  averageBudget: number;
  budgetAvailable: number;
  shareBudgetCode: string;
  budgetCoBooker: number;
  specialTermsAndConditions: CartSpecialTermsConditions[];
  approvalRequestId?: number;
}

export class CartCharacterDetailModel {
  ratingStar: number;
}


export class CartLineItemsModel {
  lineItemId: number;
  quantity: number;
}

export class CartSpecialTermsConditions {
  type: string;
  linkEn: string;
  linkTh: string;
}



// WEBPACK FOOTER //
// ./src/app/model/checkout/cart-info-model.ts